<template>
  <div>
    <CRow>
      <CCol xs="12" xl="8">
        <CCard>
          <CCardHeader>
            <strong>Υπόθεση:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Γενικές Πληροφορίες" active>
                <CCard>
                  <CCardBody>
                    <CDataTable 
                      striped 
                      small 
                      fixed
                      :items="gen_items" 
                      :fields="fields"
                    >
                      <template slot="value" slot-scope="data">
                        <td><strong>{{data.item.value}}</strong></td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
              <CTab title="Έντυπα">
                <CCard>
                  <CCardBody>
                    <PrintedForms :current_case="current_case"/>
                  </CCardBody>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="$router.push({path: '/cases/' + $route.params.id + '/edit'})">Επεξεργασία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </diV>
</template>



<script>
import axios from 'axios'
import PrintedForms from './PrintedForms'
import moment from 'moment'
export default {
  name: 'Case',
  data: () => {
    return {
      current_case: {},
      gen_items: [],
      fin_items: [],
      services: [],
      title: '',
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
    }
  },
  components: {
    PrintedForms
  },
  methods: {
    getCaseData (id) {
      const cases = casessData.find((cases, index) => index + 1 == id)
      const casesDetails = cases ? Object.entries(cases) : [['id', 'Not found']]
      return casesDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/cases/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      //const items = response.data.clients;
      self.current_case = response.data.case;
      self.title = response.data.case.case_code;
      response.data.case.status = response.data.case.status.name;
      const items = Object.entries(response.data.case).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["next_visit", "next_visit_second", "next_visit_third", "next_visit_fourth", "location", "client", "type",
                    "status", "service", "service_subcategories", "inspectors", "revision_months", "bill_status"];
      self.gen_items = items.filter((t) => keys.includes(t.key));
      self.gen_items = self.gen_items.map((item) => {
        if (item.key == "client") {
          item.value = item.value.company;
          item.key = "Πελάτης:";
        }
        if (item.key == "service") {
          item.value = item.value.name;
          item.key = "Πρότυπο ISO:";
        }
        if (item.key == "service_subcategories") {
          item.value = item.value.map((t) => {return t.name;}).join(", ");
          item.key = "EA/NACE:";
        }
        if (item.key == "bill_status" && item.value) {
          item.value = item.value.name;
        }
        if (item.key == "bill_status") {
          item.key = "Τιμολόγιο:";
        }
        if (item.key == "status") {
          item.key = "Κατάσταση:";
        }
        if (item.key == "next_visit") {
          item.key = "Επισκέψεις:";
          if (item.value[0]) {
            item.value = item.value.map((t) => moment(t, 'YYYY-MM-DD').format('DD/MM/YYYY')).join(", ")
          } else {
            item.value = '';
          }
        }
        if (item.key == "location") {
          item.key = "Τοποθεσία:";
        }
        if (item.key == "revision_months") {
          item.key = "Μήνες μέχρι την επανεξέταση:";
        }
        if (item.key == "type") {
          item.key = "Τύπος επιθεώρησης:";
        }
        if (item.key == "inspectors") {
          item.key = "Επιθεωρητής/ες:";
          item.value = item.value.map((t) => {return t.name;}).join(", ");
        }
        return item;
      });

      self.gen_items = self.gen_items.concat([
        {
          key: "Σύμβουλος/Πωλητής",
          value: response.data.case.consultant ? response.data.case.consultant.name : ''
        },
        {
          key: "Ποσό συμβούλου",
          value: response.data.case.consultant_price
        },
        {
          key: "Υπεργολάβος",
          value: response.data.case.subcontractor ? response.data.case.subcontractor.name : ''
        },
        {
          key: "Ποσό υπεργολάβου",
          value: response.data.case.subcontractor_price
        },
      ])

    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
